import React from "react";
import type { Position } from ".";
import { NAME_GAP, RANK_DELTA_Y } from "./constants";

export const GenomesTreeNodeRank = ({ p, rank }: { p: Position; rank: string }) => {
  if (!rank || rank === "no rank") {
    return null;
  }
  return (
    <text
      className="genomes-tree__nodes__item__rank"
      dominantBaseline={"middle"}
      x={p[0] + NAME_GAP}
      y={p[1] + RANK_DELTA_Y}
    >
      {rank}{" "}
    </text>
  );
};
